<!--
 * @Author: liushumin
 * @Date: 2022-09-14 18:05:05
 * @LastEditTime: 2022-09-23 11:08:40
 * @LastEditors: liushumin
-->
<template>
  <el-dialog
    title="修改费用信息"
    :visible.sync="dialogVisible_fy"
    width="650px"
    :before-close="handleClose"
    class="fyDialog"
  >
    <el-table :data="tableData" style="width: 100%; margin-top: 10px">
      <el-table-column
        prop="totalPay"
        label="商品合计"
        min-width="8%"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="freightMoney"
        label="运费"
        min-width="8%"
        align="center"
      >
        <!-- <template slot-scope="{ row }">
          <div>
            <el-input
              oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              v-model="row.freightMoney"
              size="medium"
            >
            </el-input>
          </div>
        </template> -->
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.freightMoney"
            size="medium"
            oninput="value=value.replace(/[^0-9]/g,'')"
          >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="discountPrices"
        label="优惠"
        min-width="8%"
        align="center"
      >
        <!-- <template slot-scope="{ row }">
          <div>
            <el-input
              v-model.number="row.discountPrices"
              size="medium"
              oninput="value=value.replace(/[^0-9]/g,'')"
            >
            </el-input>
          </div>
        </template> -->
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.discountPrices"
            size="medium"
            oninput="value=value.replace(/[^0-9]/g,'')"
          >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="oredrPrice"
        label="订单总金额"
        min-width="8%"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="remitMoneyPrice"
        label="应付总金额"
        min-width="8%"
        align="center"
      ></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer" style="text-align: center">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :disabled="stepLoading" @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ["openStatus", "infoFareInfo", "orderId"],
  // props: ["openStatus", "orderId"],
  data() {
    return {
      stepLoading: false,
      dialogVisible_fy: false,
      tableData: [
        {
          totalPay: "",
          oredrPrice: "",
          freightMoney: "",
          discountPrices: "",
          remitMoneyPrice: "",
          id: "",
        },
      ],
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_fy = this.openStatus;
    },
    infoFareInfo(val1, val2) {
      this.$store.state.szStatus.szDetailsObj = val1;
      this.tableData = this.$store.state.szStatus.szDetailsObj;
    },
    // tableData (val1, val2){
    //   this.tableData = val1
    // }
    // infoFareInfo(val1, val2){
    //   this.tableData = val1
    // }
  },
  mounted() {
    // this.tableData = this.infoFareInfo;
    this.tableData = this.$store.state.szStatus.szDetailsObj;
    // this.tableData = JSON.parse(sessionStorage.getItem("infoFareInfo"));
    // console.log(this.tableData);
  },
  methods: {
    // 修改费用接口
    submitForm() {
      this.stepLoading = true;
      let costParams = {
        discountPrices: this.tableData[0].discountPrices,
        freightMoney: this.tableData[0].freightMoney,
        orderId: this.orderId,
        remitMoneyPrice: this.tableData[0].remitMoneyPrice,
        totalPay: this.tableData[0].totalPay,
        oredrPrice: this.tableData[0].oredrPrice,
        id: this.tableData[0].id,
      };
      this.$http.szOrder.editCost(costParams).then((res) => {
         this.stepLoading = false;
        if (res.status == 1) {
          this.dialogVisible_fy = false;
          this.$emit("closeStatus", true);
          this.$message({
            message: "修改成功",
            type: "success",
          });
          setTimeout(() => {
            this.stepLoading = false;
          }, 1000);
        }
      });
    },
    handleClose() {
      this.dialogVisible_fy = false;
      this.$emit("closeStatus", true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../styles/order-global.scss';
</style>